export default __webpack_public_path__ + "static/media/arbitrum-one-logo.5045216f.svg";